
































import { mapState } from "vuex";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheG01ContentCategory from "@/general/components/pages/parts/Ranking/TheG01ContentCategory.vue";
import TheG01ContentPoint from "@/general/components/pages/parts/Ranking/TheG01ContentPoint.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { rankingByCategory, rankingByPoints } from "@/general/store/api";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    TheG01ContentCategory,
    TheG01ContentPoint,
    TheBreadcrumb
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class Ranking extends Vue {
  tabDefault = "category";

  tabs = [
    {
      label: "カテゴリー別",
      value: "category"
    },
    {
      label: "ポイント別",
      value: "point"
    }
  ];

  $refs!: {
    theHeader: TheHeader;
  };

  breadcrumb: any = [];

  active = "";

  get selectedContent() {
    switch (this.active) {
      case "point":
        return "TheG01ContentPoint";
      default:
        return "TheG01ContentCategory";
    }
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  @Watch("active")
  onActiveChange() {
    if (this.active == "point") {
      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: "ランキング" + " (ポイント別)",
          url: "",
          pageType: "lower"
        }
      ];
      commons.setbreadcrumb(this.breadcrumb);
    } else {
      this.breadcrumb = [
        {
          text: "",
          url: "/home",
          pageType: "home"
        },
        {
          text: "ランキング" + " (カテゴリー別)",
          url: "",
          pageType: "lower"
        }
      ];
      commons.setbreadcrumb(this.breadcrumb);
    }
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.active = this.tabDefault;
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const active = this.active == "category" ? "カテゴリー別" : "ポイント別";

    this.breadcrumb = [
      {
        text: "",
        url: "/home",
        pageType: "home"
      },
      {
        text: "ランキング" + " (" + active + ")",
        url: "",
        pageType: "lower"
      }
    ];
    await commons.setbreadcrumb(this.breadcrumb);
  }
}
